import { createContentPropTypes } from '../../../helpers/content';

const content = {
	header: 'Payment and transfers',
	makeChapsPaymentHeader: 'Make payments using CHAPS',
	subHeader:
		'Complete the details below to set up your CHAPS payment. Any fees you’ll be charged will be clearly shown before you submit your payment.',
	chapsSubHeader:
		'Please note that CHAPS payments can’t be sent on a weekend or bank holiday and must be set up and authorised by 5pm to guarantee they’ll arrive on the same day.',
	unAuthorisedMsg:
		'You don’t have permission to make payments and transfers. Please contact your corporate administrator for more information.',
	paymentsLimitMessage: 'You’ve now reached the maximum amount of Payees that you can process at the one time.',
	paymentTypeHelp:
		'Choose ‘One-off’ to move this money just once or ‘Repeating’ if you want to set up a standing order.',
	referenceHelp:
		"What this payment or transfer's for. If you're paying a company, enter the reference they've provided - this can usually be found on your bill or invoice. If you're transferring money between your own accounts, you can leave this blank.",
	radioBlockOnCancelLabel: "When it's cancelled",
	radioBlockOnNumberLabel: 'After a set number of times',
	radioBlockOnDateLabel: 'On a set date',
	frequencyLabel: 'Frequency',
	firstPaymentLabel: 'Start Date',
	stopPaymentLabel: 'Stop it',
	stopOnNumberLabel: 'Number of times',
	stopOnDateLabel: 'Stop it on',
	batchToggleLabel: 'Save time with faster tracking and authorisation.',
	batchToggleLabelSubText:
		'Batch your payments together as one transaction, making them quicker and easier to track and authorise.',
	batchToggleMoreText:
		'Only one-off payments made on the same day from the same account can be sent as a batch payment. They’ll show as a single item in your payment history but individual payments on your transactions and statements.',
	disabledBatchText: 'Only one-off payments made on the same day from the same account can be sent as a batch payment.',
	batchPaymentNameLabel: 'Batch payment name',
	batchPaymentNameSubLabel: 'Personalise this batch payment',
	invalidFormMsg:
		'We need some more information or some changes before you can continue. Please review your details and try again.',
	batchPaymentNameLabelSubText:
		'Personalise this batch payment by giving it a unique name (such as ‘Wages’ or ‘Invoices’). This is the name that’ll appear on your payment history and when authorisation is required.',
	batchInvalidMessage:
		'Only one-off payments made on the same day from the same account can be sent as a batch payment.',
	maxLimitExceededMessage: 'This exceeds the maximum amount of money you can move online per transaction.',
	billerReferenceMsg:
		'You can’t change this reference here as company references need to be verified. To make a change, go to ‘Manage your payees’.',
	creditCardReferenceMsg: 'You can’t edit the Reference for this payment.',
	billerDateMsg: 'Future-dated payments can’t be made to payees that were set up using our company search facility.',
	accountDateMsg: 'Payments from this type of account can’t be set up to be made in the future.',
	amountDescription: '',
	fromAccountDescription: '',
	toAccountDescription: '',
	paymentTypeDescription: '',
	referenceDescription: '',
	sameRefPopoverMsg:
		'We couldn’t apply this change to every reference as some references can’t be edited or left blank.',
	sameDatePopoverMsg:
		'We couldn’t apply this change to every date as some payments can’t be set up to be made in the future.',
	fromLabel: 'From',
	toLabel: 'To',
	amtLabel: 'Amount',
	templateAmtLabel: 'Amount (optional)',
	refLabel: 'Reference',
	templateRefLabel: 'Reference (optional)',
	dateLabel: 'Date',
	typeLabel: 'Type',
	editBatchHeader: 'Edit batch',
	editPaymentHeader: 'Edit payment',
	editBatchSubtext:
		'Add, delete or change the details of this batch payment. Remember that only one-off payments made on the same day from the same account can be sent as a batch payment and that there must be at least two payments.',
	addPayeeButtonTitle: 'Add new payee',
	noSearchResultMessage: 'No results',
	payeeSingularCountMessage:
		'Making more than one payment or transfer today? Save time and hassle by setting up to 150 transactions and processing them all at once.',
	copyToAllButton: 'Apply to all',
	addButton: 'Add another CHAPS payment',
	landingCreateTemplateButton: 'Create Payment Template',
	landingTemplateSectionHeader: 'Payment templates',
	templateSubText:
		'Set up your payment template by adding all the payees and payment details you want to include. Once your template’s been created and saved, you can make changes at any time.',
	templateHeader: 'Create payment template',
	editTemplateHeader: 'Edit payment template',
	saveTemplateButtonText: 'Save',
	saveTemplateAndExitButtonText: 'Save and exit',
	saveTemplateAndMakePaymentButtonText: 'Save and make payment',
	deleteTemplateModalTitle: 'Are you sure you want to delete this template?',
	deleteTemplateModalSafeActionButton: "No, don't delete",
	deleteTemplateModalDestructiveActionButton: 'Yes, delete',
	deleteTemplateModalSubText:
		'If you ever need to make another payment template using these same details, you’ll have to manually add all the details again.',
	refUpdatedMsg:
		'This new reference will be saved for this template but it won’t actually be updated until a payment is made to this payee.',
	templatePaymentSubText:
		'Make a payment quickly and simply using the details you’ve saved in your template. You can make one-off changes for this payment below, but if you want to make permanent changes to your template, you’ll have to go back and edit it.',
	paymentDateLabel: 'Payment date',
	fileUploadButtonText: 'Upload',
	fileImportText: 'Load up to {maxRecords} payment entries from a CSV or TXT file.',
	instructionsURLText: 'Read instructions (PDF)',
	templateURLText: 'Download an example (XLSX)',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
